import { render, staticRenderFns } from "./S12Taskbar.vue?vue&type=template&id=bc41fcd8&scoped=true"
import script from "./S12Taskbar.vue?vue&type=script&lang=js"
export * from "./S12Taskbar.vue?vue&type=script&lang=js"
import style0 from "./S12Taskbar.vue?vue&type=style&index=0&id=bc41fcd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc41fcd8",
  null
  
)

export default component.exports